/**
 * IL TAVOLO DEGLI SCACCHI APERTO, per chi deve chiedere «Lasciare il tavolo?» (ADR-0197 esteso agli scacchi, reference 07/10
 * punto 8). Un registro in modulo, come la pila dei livelli (`lib/livelliIndietro.ts`): la barra e il tasto indietro di Telegram
 * vivono FUORI dalla rotta, e il provider della conferma (`contexts/UscitaTavoloContext.tsx`) non puo' leggere lo stato di una
 * partita che nessun contesto dell'app tiene — il socket degli scacchi vive nella rotta (`useChessTavolo`), non in
 * `ActiveMatchContext`, quindi la rotta si REGISTRA qui finche' e' montata.
 *
 * `costaOrologio` e' una FUNZIONE, letta al tocco: lo stato cambia a ogni mossa e il registro non deve ri-registrarsi a ogni
 * orologio che scorre. Pura: niente React, niente SDK.
 */
export interface TavoloScacchiAperto {
  matchId: string;
  /** Uscire adesso costa tempo? (`uscitaCostaOrologio`, letto dall'ultimo stato al momento del tocco.) */
  costaOrologio: () => boolean;
  /**
   * L'incontro e' finito. Non e' una funzione: cambia UNA volta, e il tavolo si ri-registra (nuovo oggetto) quando cambia, cosi'
   * il provider della conferma, che ascolta il registro, si ridisegna e chiude la domanda rimasta aperta (le ANCORE della
   * domanda, ADR-0197 §2: la partita finita annulla la conferma, senza navigare).
   */
  finita: boolean;
}

let aperto: TavoloScacchiAperto | null = null;
const ascoltatori = new Set<() => void>();
const avvisa = () => {
  for (const cb of ascoltatori) cb();
};

/** Registra il tavolo. Rende la funzione che lo toglie (solo se e' ancora QUELLO: un tavolo nuovo non si perde per uno vecchio). */
export function registraTavoloScacchi(tavolo: TavoloScacchiAperto): () => void {
  aperto = tavolo;
  avvisa();
  return () => {
    if (aperto === tavolo) {
      aperto = null;
      avvisa();
    }
  };
}

export const tavoloScacchiAperto = (): TavoloScacchiAperto | null => aperto;

export function ascoltaTavoloScacchi(cb: () => void): () => void {
  ascoltatori.add(cb);
  return () => {
    ascoltatori.delete(cb);
  };
}
